// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import permissionTypes from '../../../constants/permissionTypes';
import LinkBadge from './LinkBadge';
import { getAllTerritories } from '../../../actions/territoryActions';
import { useTranslation } from 'react-i18next';

export interface TerritoryLinkProps {
  id: string;
  name: string;
  colour?: string;
  territories?: { id: string; description: string }[];
  getAllTerritories: () => Promise<void>;
}
function TerritoryLink({ id, name, colour, territories, getAllTerritories }) {
  let [localT, setLocalT] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    if (!territories) {
      getAllTerritories().catch(() => { });
    }
    setLocalT(territories?.find((x) => x.id === id));
  }, [id, territories, getAllTerritories]);

  return (
    <LinkBadge
      url={`/settings/territory/${id}`}
      name={name}
      noLinkTitle={`${localT?.description || ''}`}
      title={`${localT?.description || ''}\n` + t('(View territory)')}
      colour={colour}
      permissionType={permissionTypes.MANAGE_TERRITORIES}
    />
  );
}

function mapStateToProps(state) {
  return {
    territories: state.territories,
  };
}

const mapDispatchToProps = {
  getAllTerritories: () => getAllTerritories(),
};

export default connect(mapStateToProps, mapDispatchToProps)(TerritoryLink);
